module.exports = __webpack_public_path__ + "img/folder-plus.391a60db.svg";